import { Button, Col, Row, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";

const dataSource = [
  {
    name: "Template 1",
    shortName: "Template 1",
  },
  {
    name: "Template 2",
    shortName: "Tmplt 2",
  },
  {
    name: "Template 3",
    shortName: "Tmplt 2",
  },
  {
    name: "Template 4",
    shortName: "Tmplt 4",
  },
  {
    name: "Template 5",
    shortName: "Tmplt 5",
  },
  {
    name: "Template 6",
    shortName: "Tmplt 6",
  },
  {
    name: "Template 7",
    shortName: "Tmplt 7",
  },
];

const TemplateListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Content style={{ padding: "0px 50px 50px 50px" }}>
      <Row justify="space-between" align="middle">
        <Col>
          <h2>{t("Templates")}</h2>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate("create")}
          >
            {t("Create new")}
          </Button>
        </Col>
      </Row>
      <Row>
        <Table bordered dataSource={dataSource} style={{ width: "100%" }}>
          <Table.Column
            title={t("Name")}
            dataIndex="name"
            width="80%"
          ></Table.Column>
          <Table.Column title={t("Shortname")} dataIndex="shortName"></Table.Column>
        </Table>
      </Row>
    </Content>
  );
};

export default TemplateListPage;
